module.exports = __webpack_public_path__ + "img/75.7225fa11.jpg";